import React from 'react';
import { Modal } from 'antd';
import styled from '@emotion/styled';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { TitleModal } from '../../molecules/modal/TitleModal';
import { appStyles } from '../../../styles';
import { FormBenefit } from './forms/FormBenefit';
import { BENEFIT } from '../../../constants/define/translation';
import { WIDTH_MODAL } from '../../../constants/common';
import { PartnerType } from '../../../types/benefit';

interface FormBenefitModalProps {
  isOpenModal: boolean;
  onClose: () => void;
  record?: any;
  onRefresh: () => void;
  setIsOpenModalPartner: Function;
  setDataRecord: Function;
  partners: PartnerType[];
  countrySelected: string;
}

export const FormBenefitModal = (props: FormBenefitModalProps) => {
  const { isOpenModal, onClose, record, onRefresh, setDataRecord, partners, setIsOpenModalPartner, countrySelected } =
    props;
  const { t } = useTranslation(BENEFIT);
  return (
    <StyledModal
      title={<TitleModal title={record ? t('form.updateBenefit') : t('form.createBenefit')} />}
      centered
      visible={isOpenModal}
      width={WIDTH_MODAL}
      footer={null}
      onCancel={() => {
        onClose();
        setDataRecord(null);
      }}
      maskClosable={false}
      closeIcon={<CloseCircleOutlined />}
      forceRender
    >
      <FormBenefit
        setDataRecord={setDataRecord}
        setIsOpenModalPartner={setIsOpenModalPartner}
        onCloseModal={onClose}
        onRefresh={onRefresh}
        record={record}
        partners={partners}
        countrySelected={countrySelected}
      />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  & > .ant-modal-content {
    ${appStyles.commonModalContentStyle}
  }

  .site-card-wrapper {
    ${appStyles.background.modalBgGray}
    & .card-item {
      text-align: center;
      padding: 1rem;
    }
  }

  & h4.ant-typography {
    ${appStyles.color.black}
  }

  .ant-modal-header {
    padding-left: 0;
  }

  .card-item .ant-image {
    cursor: pointer;
  }

  & .card-up-to-date {
    & .ant-image {
      padding: 0px;
      margin-left: 12px;
      & img {
        width: 92%;
        padding: 5px 0 0px 0;
      }
    }
  }
`;
